import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { form, SanityForm } from './form';
import { formConfirmation, SanityFormConfirmation } from './formConfirmation';
import { logoMarquee, SanityLogoMarquee } from './logoMarquee';
import { media, SanityMedia } from './media';
import { richText } from './richText';
import { SanitySocialProof, socialProof } from './socialProof';

export const SanityHeroForm = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('heroForm'),
  _key: z.string(),
  // Optional for older modules that predate theming; frontend falls back to white.
  theme: z.enum(['purple', 'charcoal', 'white']).optional().nullable(),
  backgroundPattern: z.string().optional().nullable(),
  headline: z.string(),
  bodyCopy: SanityBasicText,
  formMedia: SanityMedia,
  socialProof: SanitySocialProof,
  logoMarquee: SanityLogoMarquee.optional().nullable(),
  form: SanityForm,
  formConfirmation: SanityFormConfirmation,
});

export type SanityHeroForm = z.infer<typeof SanityHeroForm>;

export const heroForm = groq`{
  _type,
  _key,
  theme,
  'backgroundPattern': background,
  headline,
  bodyCopy,
  "bodyCopy": bodyCopy[] ${richText},
  "formMedia": formMedia[0] ${media},
  "socialProof": socialProof ${socialProof},
  form-> ${form},
  formConfirmation ${formConfirmation},
  "logoMarquee": logoMarquee->sections[0] ${logoMarquee},
}`;
